import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { getRecruitmentCoverTypeList } from '../../constants/insurances/recruitment';
import { PROVIDER_SOURCE } from '../../constants/quote';
import { getGreateAmericanBusinessTypeList } from '../../localeConstants';
import { getAverageRadiusOfOperationList, getGreateAmericanYearsOfExperienceList, getOtherTypeOfOperationList, getTypeOfOperationList } from '../../localeConstants/greateAmerican';
import { ANNUAL_FLEXIBLE_KEY, ANNUAL_KEY, CONTRACT_SPECIFIC_KEY, getAnnualTypeList, getGitFixedBusinessActivities, getGitInsuranceBundleList, getGreatAmericanInsuranceBundleList } from '../../localeConstants/quote';
import { getQuoteRecruitmentBusinessTypeList } from '../../localeConstants/quotes/recruitmentQuote';
import { getQuoteBusinessTypeList, getQuoteOtherBusinessTypeList } from '../quote';
import { getGreatAmericanTypeOfRemovalJovList } from './greatAmerican';
export var getBusinessTypeDisplayText = function getBusinessTypeDisplayText(quoteDetails) {
  var _displayList, _displayList$find;

  var _ref = quoteDetails || {},
      businessType = _ref.businessType,
      providerCode = _ref.providerCode,
      businessCountry = _ref.businessCountry;

  if (!businessType) {
    return '';
  }

  var displayList = [];

  if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode)) {
    displayList = getGreateAmericanBusinessTypeList();
  } else {
    displayList = [].concat(_toConsumableArray(getQuoteBusinessTypeList(providerCode, {
      country: businessCountry
    })), _toConsumableArray(getQuoteOtherBusinessTypeList(providerCode, {
      country: businessCountry
    })));
  }

  return ((_displayList = displayList) === null || _displayList === void 0 ? void 0 : (_displayList$find = _displayList.find(function (item) {
    return item.value === businessType;
  })) === null || _displayList$find === void 0 ? void 0 : _displayList$find.label) || businessType;
};
export var getBusinessActivityDisplayText = function getBusinessActivityDisplayText(quoteDetails) {
  var _ref2 = quoteDetails || {},
      businessActivity = _ref2.businessActivity,
      providerCode = _ref2.providerCode,
      businessActivityList = _ref2.businessActivityList;

  if (!businessActivity) {
    return '';
  }

  if ([PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode)) {
    var _gitBusinessActivitie;

    var gitBusinessActivitiesList = getGitFixedBusinessActivities();
    return ((_gitBusinessActivitie = gitBusinessActivitiesList.find(function (item) {
      return item.value === businessActivity;
    })) === null || _gitBusinessActivitie === void 0 ? void 0 : _gitBusinessActivitie.label) || businessActivity;
  } else {
    var _businessActivityList;

    return (businessActivityList === null || businessActivityList === void 0 ? void 0 : (_businessActivityList = businessActivityList.find(function (item) {
      return item.value === businessActivity;
    })) === null || _businessActivityList === void 0 ? void 0 : _businessActivityList.label) || businessActivity;
  }
};
/**
 * Get the display text of the insurance bundle.
 *
 * The lookup logic mirrors `QuoteDetailInsuranceBundleCombineView` info mode
 * (libs/uikit/src/quote/insuranceBundle/combine.tsx): use the provider's
 * insurance bundle list to find the label, then fall back to the raw value.
 */

export var getInsuranceBundleDisplayText = function getInsuranceBundleDisplayText(quoteDetails) {
  var _displayList$find2;

  var _ref3 = quoteDetails || {},
      insuranceBundle = _ref3.insuranceBundle,
      providerCode = _ref3.providerCode;

  if (!insuranceBundle) {
    return '';
  }

  var displayList = [PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value, PROVIDER_SOURCE().HISCOX_US.value].includes(providerCode) ? getGreatAmericanInsuranceBundleList() : getGitInsuranceBundleList();
  return ((_displayList$find2 = displayList.find(function (item) {
    return item.value === insuranceBundle;
  })) === null || _displayList$find2 === void 0 ? void 0 : _displayList$find2.label) || insuranceBundle;
};
/**
 * Get the display text of the policy type.
 *
 * The lookup logic mirrors `QuoteDetailPolicyOfTypeCombineView` info mode
 * (libs/uikit/src/quote/policyType/combine.tsx): the available annual type
 * options depend on the provider.
 */

export var getPolicyTypeDisplayText = function getPolicyTypeDisplayText(quoteDetails) {
  var _displayList$find3;

  var _ref4 = quoteDetails || {},
      policyType = _ref4.policyType,
      providerCode = _ref4.providerCode;

  if (!policyType) {
    return '';
  }

  var displayList = getAnnualTypeList();

  if ([PROVIDER_SOURCE().CHUBB.value].includes(providerCode)) {
    displayList = displayList.filter(function (item) {
      return [ANNUAL_FLEXIBLE_KEY, CONTRACT_SPECIFIC_KEY].includes(item.value);
    });
  } else if ([PROVIDER_SOURCE().ACCELERANT.value].includes(providerCode)) {
    displayList = displayList.filter(function (item) {
      return item.value === ANNUAL_KEY;
    });
  } else {
    displayList = displayList.filter(function (item) {
      return [ANNUAL_KEY, CONTRACT_SPECIFIC_KEY].includes(item.value);
    });
  }

  return ((_displayList$find3 = displayList.find(function (item) {
    return item.value === policyType;
  })) === null || _displayList$find3 === void 0 ? void 0 : _displayList$find3.label) || policyType;
};
/**
 * Get the display text of the recruitment business type.
 *
 * The lookup logic mirrors `QuoteDetailRecruitmentBusinessTypeCombineView` info
 * mode (libs/uikit/src/quote/recruitment/recruitmentBusinessType/combine.tsx).
 */

export var getRecruitmentBusinessTypeDisplayText = function getRecruitmentBusinessTypeDisplayText(quoteDetails) {
  var _getQuoteRecruitmentB;

  var _ref5 = quoteDetails || {},
      recruitmentBusinessType = _ref5.recruitmentBusinessType,
      labels = _ref5.labels;

  if (!recruitmentBusinessType) {
    return '';
  }

  return ((_getQuoteRecruitmentB = getQuoteRecruitmentBusinessTypeList().find(function (item) {
    return item.value === recruitmentBusinessType;
  })) === null || _getQuoteRecruitmentB === void 0 ? void 0 : _getQuoteRecruitmentB.label) || (labels === null || labels === void 0 ? void 0 : labels[recruitmentBusinessType]) || recruitmentBusinessType;
};
/**
 * Get the display text of the cover type.
 *
 * The lookup logic mirrors `QuoteDetailCoverTypeCombineView` info mode
 * (libs/uikit/src/quote/coverType/combine.tsx).
 */

export var getCoverTypeDisplayText = function getCoverTypeDisplayText(quoteDetails) {
  var _getRecruitmentCoverT;

  var _ref6 = quoteDetails || {},
      coverType = _ref6.coverType;

  if (!coverType) {
    return '';
  }

  return ((_getRecruitmentCoverT = getRecruitmentCoverTypeList().find(function (item) {
    return item.value === coverType;
  })) === null || _getRecruitmentCoverT === void 0 ? void 0 : _getRecruitmentCoverT.label) || coverType;
};
/**
 * Get the display text of the type of removal job.
 *
 * The lookup logic mirrors `QuoteDetailTypeOfRemovalJobCombineView` info mode
 * (libs/uikit/src/quote/greatAmerican/typeOfRemovalJob/combine.tsx).
 */

export var getTypeOfRemovalJobDisplayText = function getTypeOfRemovalJobDisplayText(quoteDetails) {
  var _displayList$find4;

  var _ref7 = quoteDetails || {},
      typeOfOperation = _ref7.typeOfOperation,
      declarationQuestions = _ref7.declarationQuestions;

  if (!typeOfOperation) {
    return '';
  }

  var list = getTypeOfOperationList().filter(function (item) {
    return item.value !== 'other';
  });
  var displayList = getGreatAmericanTypeOfRemovalJovList([].concat(_toConsumableArray(list), _toConsumableArray(getOtherTypeOfOperationList())), {
    declarationQuestions: declarationQuestions,
    isFastTrack: false
  });
  return ((_displayList$find4 = displayList.find(function (item) {
    return item.value === typeOfOperation;
  })) === null || _displayList$find4 === void 0 ? void 0 : _displayList$find4.label) || typeOfOperation;
};
/**
 * Get the display text of the average radius of operation.
 *
 * The lookup logic mirrors `QuoteDetailAverageRadiusOperationCombineView` info
 * mode (libs/uikit/src/quote/greatAmerican/averageRadiusOperation/combine.tsx).
 */

export var getAverageRadiusOperationDisplayText = function getAverageRadiusOperationDisplayText(quoteDetails) {
  var _getAverageRadiusOfOp;

  var _ref8 = quoteDetails || {},
      averageRadiusOfOperation = _ref8.averageRadiusOfOperation;

  if (!averageRadiusOfOperation) {
    return '';
  }

  return ((_getAverageRadiusOfOp = getAverageRadiusOfOperationList().find(function (item) {
    return item.value === averageRadiusOfOperation;
  })) === null || _getAverageRadiusOfOp === void 0 ? void 0 : _getAverageRadiusOfOp.label) || averageRadiusOfOperation;
};
/**
 * Get the display text of the years in business.
 *
 * The lookup logic mirrors `QuoteDetailYearsInBusinessCombineView` info mode
 * (libs/uikit/src/quote/greatAmerican/yearsOfExperience/combine.tsx).
 */

export var getYearsInBusinessDisplayText = function getYearsInBusinessDisplayText(quoteDetails) {
  var _getGreateAmericanYea;

  var _ref9 = quoteDetails || {},
      yearsInBusiness = _ref9.yearsInBusiness;

  if (!yearsInBusiness) {
    return '';
  }

  return ((_getGreateAmericanYea = getGreateAmericanYearsOfExperienceList().find(function (item) {
    return item.value === yearsInBusiness;
  })) === null || _getGreateAmericanYea === void 0 ? void 0 : _getGreateAmericanYea.label) || yearsInBusiness;
};